<template>
  <div class="flex flex-col items-center text-guardian-secondary-0 justify-center">
    <LogoImg />
    <LogoText class="text-guardian-secondary-0 mt-5" />
  </div>
</template>
<script setup>
import LogoText from './LogoText.vue'
import LogoImg from './LogoImg.vue'
</script>
